var map = {
	"./ace_archer/data": 640,
	"./ace_archer/data.json": 640,
	"./balloon_burst/data": 641,
	"./balloon_burst/data.json": 641,
	"./balloon_popper/data": 642,
	"./balloon_popper/data.json": 642,
	"./battlefield/data": 643,
	"./battlefield/data.json": 643,
	"./berkshire_buffet/data": 644,
	"./berkshire_buffet/data.json": 644,
	"./bottle_breaker/data": 645,
	"./bottle_breaker/data.json": 645,
	"./bug_blast/data": 646,
	"./bug_blast/data.json": 646,
	"./build_the_parthenon/data": 647,
	"./build_the_parthenon/data.json": 647,
	"./carnival_slots/data": 648,
	"./carnival_slots/data.json": 648,
	"./castle_run/data": 649,
	"./castle_run/data.json": 649,
	"./catchem_butterflies/data": 650,
	"./catchem_butterflies/data.json": 650,
	"./catchem_jellyfish/data": 651,
	"./catchem_jellyfish/data.json": 651,
	"./catchup_bottles/data": 652,
	"./catchup_bottles/data.json": 652,
	"./city_cross/data": 653,
	"./city_cross/data.json": 653,
	"./city_rider/data": 654,
	"./city_rider/data.json": 654,
	"./city_slots/data": 655,
	"./city_slots/data.json": 655,
	"./climb_mount_olympus/data": 656,
	"./climb_mount_olympus/data.json": 656,
	"./corpoladder/data": 657,
	"./corpoladder/data.json": 657,
	"./cricket_chase/data": 658,
	"./cricket_chase/data.json": 658,
	"./cross_the_street/data": 659,
	"./cross_the_street/data.json": 659,
	"./cruise_ship/data": 660,
	"./cruise_ship/data.json": 660,
	"./desert_quest/data": 661,
	"./desert_quest/data.json": 661,
	"./dialogger_simulation/data": 662,
	"./dialogger_simulation/data.json": 662,
	"./dialogger_simulation/gamedata": 663,
	"./dialogger_simulation/gamedata.json": 663,
	"./digital_marketing/data": 664,
	"./digital_marketing/data.json": 664,
	"./digital_marketing_slot/data": 665,
	"./digital_marketing_slot/data.json": 665,
	"./drone_delivery/data": 666,
	"./drone_delivery/data.json": 666,
	"./druid_slots/data": 667,
	"./druid_slots/data.json": 667,
	"./duck_shooter/data": 668,
	"./duck_shooter/data.json": 668,
	"./energy_saver/data": 669,
	"./energy_saver/data.json": 669,
	"./everest_chase/data": 670,
	"./everest_chase/data.json": 670,
	"./fly_fishing/data": 671,
	"./fly_fishing/data.json": 671,
	"./food_finder/data": 672,
	"./food_finder/data.json": 672,
	"./gear_up/data": 673,
	"./gear_up/data.json": 673,
	"./ghost_dusters/data": 674,
	"./ghost_dusters/data.json": 674,
	"./got_milk/data": 675,
	"./got_milk/data.json": 675,
	"./haunted_castle/data": 676,
	"./haunted_castle/data.json": 676,
	"./hotel_jackpot/data": 677,
	"./hotel_jackpot/data.json": 677,
	"./jackpot_bus/data": 678,
	"./jackpot_bus/data.json": 678,
	"./jersey_wheel_of_fortune/data": 679,
	"./jersey_wheel_of_fortune/data.json": 679,
	"./long_road/data": 680,
	"./long_road/data.json": 680,
	"./maze_runner/data": 681,
	"./maze_runner/data.json": 681,
	"./mind_the_trees/data": 682,
	"./mind_the_trees/data.json": 682,
	"./mountain_quest/data": 683,
	"./mountain_quest/data.json": 683,
	"./movie_spin/data": 684,
	"./movie_spin/data.json": 684,
	"./ninja_run/data": 685,
	"./ninja_run/data.json": 685,
	"./pearl_seeker/data": 686,
	"./pearl_seeker/data.json": 686,
	"./product_launch_roulette/data": 687,
	"./product_launch_roulette/data.json": 687,
	"./rescue_princess/data": 688,
	"./rescue_princess/data.json": 688,
	"./scarab_beetles/data": 689,
	"./scarab_beetles/data.json": 689,
	"./shield_grabber/data": 690,
	"./shield_grabber/data.json": 690,
	"./sparta_arsenal/data": 691,
	"./sparta_arsenal/data.json": 691,
	"./sphinx_grab/data": 692,
	"./sphinx_grab/data.json": 692,
	"./starfall/data": 693,
	"./starfall/data.json": 693,
	"./strategy_popper/data": 694,
	"./strategy_popper/data.json": 694,
	"./supply_run/data": 695,
	"./supply_run/data.json": 695,
	"./sweet_surprise/data": 696,
	"./sweet_surprise/data.json": 696,
	"./taxi_driver/data": 697,
	"./taxi_driver/data.json": 697,
	"./the_beach_adventure/data": 698,
	"./the_beach_adventure/data.json": 698,
	"./ticket_wheel_of_fortune/data": 699,
	"./ticket_wheel_of_fortune/data.json": 699,
	"./tight_rope_icici/data": 700,
	"./tight_rope_icici/data.json": 700,
	"./tightrope_juggler/data": 701,
	"./tightrope_juggler/data.json": 701,
	"./treasure_chest/data": 702,
	"./treasure_chest/data.json": 702,
	"./turtle_bay/data": 703,
	"./turtle_bay/data.json": 703,
	"./yeti_busters/data": 704,
	"./yeti_busters/data.json": 704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1259;